import Right from 'assets/icons/Right';
import Chip from 'common/components/Chip';
import React from 'react';
import { useIntegrationSettings } from 'settings/contexts/IntegrationSettingsContext';

export const IntegrationStatus = ({ integration }) => {
  const { companySettings, t } = useIntegrationSettings();

  if (integration?.slug !== 'SAPSF') return null;

  const settingKey = integration.slug.toLowerCase() + '_is_enabled';
  const isEnabled =
    companySettings?.find((s) => s.name === settingKey)?.value === 'true';

  return (
    <Chip variant={isEnabled ? 'success' : 'alert'}>
      {t(isEnabled ? 'connected' : 'not-connected')}
    </Chip>
  );
};

const IntegrationCard = ({ handleCardClick, integration }) => {
  const { t } = useIntegrationSettings();

  return (
    <div
      className='w-[300px] p-4 border border-gray-300 rounded-lg shadow-sm cursor-pointer hover:shadow-md flex flex-col gap-4 bg-gray-50'
      onClick={() => handleCardClick(integration)}
    >
      <div className='flex flex-col gap-1'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-2'>
            {integration.icon}
            <span className='font-semibold text-raisin-black text-lg'>
              {integration.name}
            </span>
          </div>
          <Right size='16px' color='#6B7280' />
        </div>
        <div className='flex items-center'>
          <IntegrationStatus integration={integration} />
        </div>
      </div>
      <div className='h-full flex flex-col justify-between gap-2'>
        <p className='text-gray-400 text-sm font-semibold'>
          {integration.slug === 'WORKABLE'
            ? t('workable-description')
            : integration.slug === 'SAPSF'
            ? t('sapsf-description')
            : ''}
        </p>
        {/* <SyncDate integration={integration} /> */}
      </div>
    </div>
  );
};

export default IntegrationCard;
